import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedShell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import SalesLog from "@/pages/SalesLog";
import VehicleDealer from "@/pages/VehicleDealer";
import Money from "@/pages/Money";
import Commissions from "@/pages/Commissions";
import Mechanics from "@/pages/Mechanics";
import Catalog from "@/pages/Catalog";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedShell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/pos" element={<POS />} />
              <Route path="/pd-ems" element={<POS variant="pd" />} />
              <Route path="/sales" element={<SalesLog />} />
              <Route path="/dealer" element={<VehicleDealer />} />
              <Route path="/money" element={<Money />} />
              <Route path="/commissions" element={<Commissions />} />
              <Route path="/mechanics" element={<Mechanics />} />
              <Route path="/catalog" element={<Catalog />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
